import { useEffect } from 'react';

export const useOutsideClick = ({ onCallback, ref }) => {
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (ref?.current && !ref?.current.contains(event.target)) {
        onCallback();
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => document.removeEventListener('click', handleOutsideClick);
  }, [ref]);
};
